import { useCallback } from 'react';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import { getCdnUrl } from '@/helpers';
import { useLog } from '@/hooks/useLog';
import PortalProps from '@/interfaces/portals';
import { StyledProp } from '@/styled';

export const PORTALS_CARD_IMAGE_HEIGHT = 200;

interface PortalCardProps extends StyledProp, PortalProps {}

const PortalCard = ({ title, image, old_image, domain, subdomain, thumbnail, id }: PortalCardProps) => {
  const currentImage = getCdnUrl(thumbnail, image, old_image);
  const currentUrl = domain ?? subdomain;
  const { activity } = useLog();

  const handleClick = useCallback(() => {
    window.open(currentUrl, '_blank');
    activity('clickSchool', { message: `Clicou na escola com subdomínio: ${currentUrl} (${id})` });
  }, [currentUrl, activity, id]);

  return (
    <BaseCard image={{ src: currentImage, aspect: '1:1' }} onClick={handleClick}>
      <Typography.Text strong ellipsis>
        {title}
      </Typography.Text>
    </BaseCard>
  );
};

export default PortalCard;
